import React from 'react';
import './App.css';
import firebase from "firebase/app";
import {Provider as ReduxProvider} from 'react-redux';
import {store} from "./redux/store";
import {BrowserRouter, Redirect, Route, Switch as RouterSwitch} from "react-router-dom";
import {FirebaseAuthProvider} from "@react-firebase/auth";
import {LogInScreen} from "./auth/components/LogInScreen";
import {PrivateRoute} from "./auth/components/PrivateRoute";
import {AppAuthProvider} from "./auth/components/AuthProvider";
import {AdminApp} from "./features/adminApp/AdminApp";
import {FirestoreProvider} from "@react-firebase/firestore";
import {MuiThemeProvider} from "@material-ui/core";
import {WorkerApp} from "./features/workerApp/WorkerApp";
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import OrderEngine from "./orderEngine/OrderEngine";
import {OrderConfirmation} from "./orderEngine/steps/OrderConfirmation";
import {de} from "date-fns/locale";
import {theme} from "./theme";
import {AppSlashRedirect} from "./AppSlashRedirect";

const firebaseConfig = {
    apiKey: "AIzaSyAsR8qHbW4OpbT8gk7F1dklEgJRizlrab8",
    authDomain: "online-buchungstool-a9b5b.firebaseapp.com",
    projectId: "online-buchungstool-a9b5b",
    storageBucket: "online-buchungstool-a9b5b.appspot.com",
    messagingSenderId: "553091464947",
    appId: "1:553091464947:web:b023d5b966aec46eedc186",
    measurementId: "G-49MDVBZK1J",
    databaseURL: ''
};

/*const OfflineSnackBar: FC = () => {
    return (
        <Offline>
            <Snackbar
                open
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert severity="error">
                    <AlertTitle>No Internet</AlertTitle>
                    Check your Internet Connection
                </Alert>
            </Snackbar>
        </Offline>
    )
}*/

function App() {
    return (
        <ReduxProvider store={store}>
            <FirebaseAuthProvider firebase={firebase} {...firebaseConfig}>
                <FirestoreProvider {...firebaseConfig} firebase={firebase}>
                    <AppAuthProvider>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={de}>
                               <BrowserRouter>
                                <MuiThemeProvider theme={theme}>
                                   {/* <OfflineSnackBar/>*/}
                                    <RouterSwitch>
                                        <Route exact path="/">
                                            <AppSlashRedirect/>
                                        </Route>
                                        <Route path="/login">
                                            <LogInScreen/>
                                        </Route>
                                        <Route path="/order-engine">
                                            <OrderEngine/>
                                        </Route>
                                        <Route path="/confirmation/:orderId">
                                            <OrderConfirmation/>
                                        </Route>
                                        <PrivateRoute path="/worker" authorizedRole="worker">
                                            <WorkerApp/>
                                        </PrivateRoute>
                                        <PrivateRoute path="/admin" authorizedRole="admin">
                                            <AdminApp/>
                                        </PrivateRoute>
                                        <Route path='*' exact={true} component={() => (<Redirect to={"/login"}/>)}/>
                                    </RouterSwitch>
                                </MuiThemeProvider>
                            </BrowserRouter>
                        </MuiPickersUtilsProvider>
                    </AppAuthProvider>
                </FirestoreProvider>
            </FirebaseAuthProvider>
        </ReduxProvider>
    );
}

export default App;
